import React from "react";

// import a1 from '../../../assets/img/leatzmeat/about-chicken.png'
import { TiTick } from "react-icons/ti";
function AboutStory({ data, t }) {
  return (
    <>
      <div className="aboutSection p-30">
        <div className="container">
          <div className="costInfoContent border-0 p-0">
            <h3>About EHL Life Sciences Pvt. Ltd.</h3>
            <p>
              At EHL Life Sciences Pvt Ltd, we are dedicated to improving animal
              health and farm productivity through high-quality veterinary feed
              supplements specially formulated for cattle and poultry. We
              understand the practical challenges Indian farmers face, and our
              products are designed to support better weight gain, stronger
              immunity, and improved overall health in livestock and
              poultry—whether in small rural setups or large commercial farms.
            </p>
            <p>
              Our supplements are manufactured in ISO-certified, GMP-compliant
              facilities. We use quality ingredients and carefully tested
              formulations to ensure every product is safe, effective, and
              consistent. From feed additives to vitamin-mineral mixes, we focus
              on results that farmers can see in their animals' performance and
              well-being.
            </p>
            <p>
              Alongside our own range of products, we offer custom third-party
              manufacturing and private-label services to veterinary companies,
              agri-input suppliers and new brands entering the market. Whether
              you need help developing a specific formulation or want to scale
              up an existing product, our team provides end-to-end support—from
              product development and testing to manufacturing, packaging, and
              delivery. We understand the importance of confidentiality and
              flexibility in this space, and we work closely with each client to
              meet their unique needs.
            </p>
            <p>
              With a growing presence across India and a strong focus on
              quality, reliability, and customer satisfaction, EHL Life Sciences
              Pvt Ltd is proud to be a trusted partner in the veterinary and
              livestock nutrition industry. We’re here to help farmers, vets,
              and agri-businesses build healthier herds, better yields, and
              stronger rural communities.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutStory;
